import { takeLatest, call, put, select } from 'redux-saga/effects'

import I18n from 'i18n'
import editRequestCourse, {
  EditRequestCourseParams,
  ResponseEditRequestCourse,
} from 'api/requestCourses/EditRequestCourse'
import admin, { ResponseRequestCourses } from 'api/requestCourses/ListAdmin'
import supervisor from 'api/requestCourses/ListSupervisor'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import {
  EDIT_REQUEST_OUTSIDE_COURSE,
  Actions,
} from '../../actions/requestOutsideCourses.action'
import { ActionWithPayload } from '../../../helpers/redux-actions.helper'
import { IPermissionModel } from '../../../models/permission.model'
import { IMainState } from '../../states'

const pattern = EDIT_REQUEST_OUTSIDE_COURSE

export type EditRequestCourseAction = ActionWithPayload<
  typeof pattern,
  {
    params: EditRequestCourseParams
    onSuccess?(): void
    onError?(err: any): void
  }
>

function* editRequestCourseEffectSaga(action: EditRequestCourseAction) {
  const { params, onSuccess, onError } = action.payload
  try {
    // eslint-disable-next-line
    const res: ResponseEditRequestCourse = yield call(editRequestCourse, params)

    const [permission]: [IPermissionModel] = yield select(
      ({ user }: IMainState) => [user.permission]
    )

    try {
      if (permission?.admin) {
        const data: ResponseRequestCourses = yield call(admin)

        yield put(Actions.setListAdminSuccess(data))
      }

      if (permission?.supervisor) {
        const data: ResponseRequestCourses = yield call(supervisor)

        yield put(Actions.setListSupervisorSuccess(data))
      }
    } catch (error) {
      console.error(error)
    }

    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
    if (onSuccess) onSuccess()
  } catch (error) {
    console.error('error: ', error)
    if (onError) onError(error)
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    yield put(Actions.setLoading(false))
  }
}

export function* editRequestCourseWatcherSaga() {
  yield takeLatest(pattern, editRequestCourseEffectSaga)
}
